<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc"  :index="questionAnswer" :items="questionItem" v-on:selected="selected"></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section1/1-3" :selected="selectedValue" required="true">Submit</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import QuestionBox from "../../components/QuestionBox";
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-2",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  data(){
    return {
      questionTitle: "Question 2",
      questionDesc: "Persistent albuminuria in T2D and CKD is:",
      questionItem:[
        "Associated with CV risk",
        "Associated with progression of CKD",
        "Recognised as a treatment target",
        "All of the above"
      ],
      selectedValue:'',
      questionAnswer:'3',
      noticeTxt:'CKD, chronic kidney disease, CV, cardiovascular; T2D  type 2 diabetes.',
      title:"Pre-activity quiz"
    }
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>

</style>
